module.exports = __webpack_public_path__ + "img/plus-icon.69d36260.svg";